module.exports = true;



//////////////////
// WEBPACK FOOTER
// /Users/Fuunnx/workspace/zygmund/~/core-js/library/modules/_library.js
// module id = ../../../node_modules/core-js/library/modules/_library.js
// module chunks = 0